<template>
  <div class="overcomeCorona">
    <v-container>
      <section class="hero justify-center align-center column">
        <h1><span>코로나19</span> 상생 프로젝트</h1>
        <h2>동료 사장님들께 공유하면<br />
            혜택을 더 드려요!<br />
            최대 천만원 추가 지원!</h2>
        <h3>동료 사장님들과 함께라면<br /><span>이겨낼 수 있습니다</span></h3>
        <span>#힘내라소상공인 #최대천만원추가 #당일실행</span>
        <img src="@/assets/images/landing/main-top.svg" alt="together-group-01"/>
      </section>
      <section class="section__banner">
        <h3>현재 펀다와 함께 극복해나가는 사장님들</h3>
        <span class="current__borrowers">
          <ICountUp :endVal="totalBorrowers||0" :delay="500"/>명
        </span>
      </section>
      <section class="section__check-list">
        <v-list disabled>
          <v-list-item-group>
            <v-list-item>
              <v-list-item-icon>
                <v-icon
                  large
                  color="primary darken-2"
                >
                  mdi-check
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  카카오톡으로 내 주변 사장님들에게 공유해주세요!
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon
                  large
                  color="primary darken-2"
                >
                  mdi-check
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  새로운 사장님들이 펀다와 함께할 수록 공유한 사장님도 공유받은 사장님도 추가한도 20% 최대 1000만원까지 지원드립니다
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </section>
      <div class="floating__action-button">
        <v-btn @click="kakaoShare" large fixed>
          <img src="@/assets/images/kakao_symbol.svg" />
          동료 사장님께 바로 알려주기!
        </v-btn>
      </div>
    </v-container>
  </div>
</template>
<script>
import { linkShare } from '@/plugins/kakao'

export default {
  name: 'overcomeCoronaB',
  data() {
    return {
      totalBorrowers: 29178,
      utm_source: this.getUrlParameter('utm_source'),
      utm_medium: this.getUrlParameter('utm_medium'),
      utm_campaign: this.getUrlParameter('utm_campaign'),
      utm_content: this.getUrlParameter('utm_content'),
    }
  },
  methods: {
    getUrlParameter(sParam) {
      let uri = window.location.search.substring(1)
      let params = new URLSearchParams(uri)
      return params.get(sParam)
    },
    kakaoShare() {
      const weblink = `https://now.funda.kr/landing/invitation/corona?utm_source=${this.utm_source}&utm_medium=${this.utm_medium}&utm_campaign=${this.utm_campaign}&utm_content=${this.utm_content}`
      const msg = {
        objectType: 'feed',
        content: {
          title: '동료 사장님과 함께 이겨내요!',
          description: '매일 1,000명이 받는 중금리 혜택, 동료사장님도 함께 받기',
          imageUrl:
            'https://s3.ap-northeast-2.amazonaws.com/cdn.funda.kr/funda-now/img/landing/landing_thumbnail01.png',
          link: {
            mobileWebUrl: weblink,
            webUrl: weblink,
          },
        },
        social: {
          likeCount: 986,
          sharedCount: 745,
        },
        buttons: [
          {
            title: '오늘 혜택 조회!',
            link: {
              mobileWebUrl: weblink,
              webUrl: weblink,
            },
          },
        ],
        installTalk: true,
      }
      linkShare(msg)
    }
  }
}

</script>
<style lang="scss" scoped>
.overcomeCorona {
  .container {
    padding: 0;
  }

  .hero {
    background-color: #a6d0ff;
    border-radius: 0 0 50% 50% / 90px;
    align-items: center;
    text-align: center;
    padding-top: 30px;
    overflow:hidden;
    max-height: 500px;

    h1 {
      color: #ffffff;
      font-weight: 900;
      font-size: 2rem;
    }
    h2{
      margin-top: 25px;
      font-size: 37px;
      line-height: 1.3;
      color: #037cda;
      font-weight: 900;
    }
    h3 {
      display: none;
      color: #3598DB;
      font-size: 1.5rem;
      line-height: 1.4;
      font-weight: 800;

      span {
        color: #037cda;
      }
    }
    p {
      margin-top: 20px;
      font-weight: 900;
      font-size: 20px;
      color: #333333;
    }
    @media screen and (max-width: 680px) {
      max-height: 470px;

      h2 {
        font-size: 30px;
      }

      img {
        bottom: 18px;
      }
    }
  }

  .section {
    &__banner {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 37px;

      h3 {
        text-align: center;
        line-height: 1.5;
      }

      .current__borrowers {
        font-size: 59px;
        font-weight: 800;
        margin-top: 10px;
        color: #037cda;
      }

      @media screen and (max-width: 680px) {
        padding-bottom: 10px;
      }
    }

    &__check-list {
      padding-left: 20px;
      padding-right: 20px;

      .v-list-item {
        &__icon {
          .v-icon{
            color: #037cda;
          }
        }
        &__content {
          overflow: initial;
          padding-left: 9px;
        }
        .v-list-item__title {
          white-space: pre-wrap;
          font-size: 18px;
          line-height: 1.5;
        }
      }
      @media screen and (max-width: 680px) {
        padding-bottom: 80px;
      }
    }
  }

  .floating__action-button {
    .v-btn {
      background-color: #ffe500 !important;
      -webkit-box-shadow: 0 8px 14px 0 rgb(0 0 0 / 14%);
      box-shadow: 0 8px 14px 0 rgb(0 0 0 / 14%);
      color: #252525;
      letter-spacing: 0px;
      font-size: 18px;
      font-weight: 900;
      height: 64px;
      padding: 15px 15px;
      max-width: 680px;
      width: 100%;
      font-weight: 700;
      bottom: 0;
      z-index: 2;

      img {
        width: 20px;
        margin-right: 5px;
      }
    }
  }
}
</style>
